import type { PaymentMethodType } from "@moonpay/platform-protocol/api";
import type { ExecutableQuote } from "../../../lib/buy/quote.types";
import { cardHeadless } from "./card";
import { PAYMENT_BUTTONS } from "./registry";
import { bankTransferHeadless } from "./sepa";
import type { PaymentButton } from "./buttons.types";

export function resolveButton(paymentMethod: PaymentMethodType): PaymentButton | undefined {
  return PAYMENT_BUTTONS.find((button) => button.paymentMethods.includes(paymentMethod));
}

export function resolveHeadlessPayment(quote: ExecutableQuote): PaymentButton | undefined {
  if (quote.exchangeRateType === "floating") {
    return bankTransferHeadless;
  }
  return quote.paymentMethod.type === "card" ? cardHeadless : undefined;
}
